(function () {
  'use strict';

  // Recipe facts are generated from the exact-current supplier specification rows.
  // Prices, order thresholds and tokens remain owned by PrepareHQV1714Reserve.
  // BEGIN GENERATED RECIPE FACTS
  var RECIPE_FACTS = {
    "chicken-fajita": {
      "supplierSku": "842300",
      "category": "main",
      "servingsPerTin": 8,
      "vegetarian": false,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "chilli-con-carne": {
      "supplierSku": "860300",
      "category": "main",
      "servingsPerTin": 8,
      "vegetarian": false,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "macaroni-cheese": {
      "supplierSku": "844300",
      "category": "main",
      "servingsPerTin": 10,
      "vegetarian": true,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "pasta-bolognaise": {
      "supplierSku": "840300",
      "category": "main",
      "servingsPerTin": 8,
      "vegetarian": false,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "salmon-broccoli-pasta": {
      "supplierSku": "846300",
      "category": "main",
      "servingsPerTin": 8,
      "vegetarian": false,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "chicken-tikka": {
      "supplierSku": "841300",
      "category": "main",
      "servingsPerTin": 8,
      "vegetarian": false,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "spicy-pasta-arabiata": {
      "supplierSku": "899300",
      "category": "main",
      "servingsPerTin": 7,
      "vegetarian": true,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "vegetable-chilli": {
      "supplierSku": "845300",
      "category": "main",
      "servingsPerTin": 7,
      "vegetarian": true,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "five-bean-cassoulet": {
      "supplierSku": "898300",
      "category": "main",
      "servingsPerTin": 7,
      "vegetarian": true,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "morning-oats": {
      "supplierSku": "849300",
      "category": "breakfast",
      "servingsPerTin": 15,
      "vegetarian": true,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "scrambled-egg-cheese": {
      "supplierSku": "848300",
      "category": "breakfast",
      "servingsPerTin": 8,
      "vegetarian": true,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "scrambled-egg": {
      "supplierSku": "856300",
      "category": "breakfast",
      "servingsPerTin": 10,
      "vegetarian": true,
      "claimState": "exact-current",
      "transitionWatch": false
    },
    "rice-pudding": {
      "supplierSku": "830300",
      "category": "dessert",
      "servingsPerTin": 13,
      "vegetarian": true,
      "claimState": "exact-current",
      "transitionWatch": false
    }
  };
  // END GENERATED RECIPE FACTS

  Object.keys(RECIPE_FACTS).forEach(function (id) { Object.freeze(RECIPE_FACTS[id]); });
  Object.freeze(RECIPE_FACTS);
  // Automatic suggestions use the currently approved online range. Keep the
  // other verified recipes in RECIPE_FACTS for explicit enquiry selections and
  // saved mixes; specification evidence alone does not make a recipe buyable.
  var ROTATIONS = Object.freeze({
    mixed: Object.freeze(['chicken-fajita', 'chilli-con-carne', 'macaroni-cheese', 'pasta-bolognaise', 'spicy-pasta-arabiata', 'vegetable-chilli', 'five-bean-cassoulet']),
    vegetarian: Object.freeze(['macaroni-cheese', 'five-bean-cassoulet', 'vegetable-chilli', 'spicy-pasta-arabiata']),
    breakfast: Object.freeze(['morning-oats', 'scrambled-egg-cheese']),
    pudding: Object.freeze(['rice-pudding'])
  });
  var PATTERN_IDS = Object.freeze({ m: 'one-main', main: 'one-main', bm: 'breakfast-main', bmp: 'breakfast-main-pudding', b2mp: 'breakfast-two-main-pudding' });
  var PERIOD_IDS = Object.freeze({ 1: '1-month', 3: '3-months', 6: '6-months', 12: '12-months' });
  var CATEGORY_KEYS = Object.freeze(['breakfast', 'main', 'pudding']);

  function invalid(message) { return { valid: false, errors: Array.isArray(message) ? message : [message] }; }
  function chosenNumber(value, allowed) {
    if (typeof value === 'string' && /^[1-9]\d*$/.test(value)) value = Number(value);
    return allowed.indexOf(value) >= 0 ? value : null;
  }
  function defaultReserveApi() {
    if (typeof window !== 'undefined' && window.PrepareHQV1714Reserve) return window.PrepareHQV1714Reserve;
    if (typeof module !== 'undefined' && module.exports && typeof require === 'function') return require('./preparehq-v1.7.11.js');
    return null;
  }

  function recommendWithApi(reserveApi, catalogueData, input) {
    if (!reserveApi || typeof reserveApi.createCatalogue !== 'function' || typeof reserveApi.calculatePlanner !== 'function' || typeof reserveApi.encodeSelection !== 'function' || typeof reserveApi.encodePlannerState !== 'function') return invalid('The food calculator is unavailable. Please reload the page.');
    if (!input || typeof input !== 'object' || Array.isArray(input)) return invalid('Choose your household, period and daily food pattern.');
    var people = chosenNumber(input.people, [1, 2, 3, 4, 5, 6, 7, 8]);
    var months = chosenNumber(input.months, [1, 3, 6, 12]);
    var patternId = typeof input.pattern === 'string' ? PATTERN_IDS[input.pattern] : null;
    var diet = typeof input.diet === 'undefined' ? 'mixed' : input.diet;
    var errors = [];
    if (!people) errors.push('Choose a whole number of people from 1 to 8.');
    if (!months) errors.push('Choose 1, 3, 6 or 12 months.');
    if (!patternId) errors.push('Choose one of the listed daily food patterns.');
    if (diet !== 'mixed' && diet !== 'vegetarian') errors.push('Choose mixed recipes or vegetarian recipes.');
    if (errors.length) return invalid(errors);

    var catalogue;
    try { catalogue = reserveApi.createCatalogue(catalogueData); }
    catch (error) { return invalid('The recipe catalogue could not be verified. Please reload the page.'); }
    var planner = reserveApi.calculatePlanner({ people: people, periodId: PERIOD_IDS[months], patternId: patternId });
    if (!planner || !planner.valid) return invalid('The chosen food plan could not be calculated.');
    var pattern = reserveApi.plannerPatterns[patternId];
    if (!pattern || catalogueData.tinsPerCase !== 6 || catalogueData.minimumCases !== 1) return invalid('The food-order rules could not be verified.');
    var requested = { breakfast: planner.counts.breakfast, main: planner.counts.main, pudding: planner.counts.pudding };
    var supplied = { breakfast: 0, main: 0, pudding: 0 };
    var rotations = { breakfast: ROTATIONS.breakfast, main: ROTATIONS[diet], pudding: ROTATIONS.pudding };
    var builderById = Object.create(null);
    catalogue.builderRecipes.forEach(function (recipe) { builderById[recipe.id] = recipe; });
    CATEGORY_KEYS.forEach(function (category) {
      if (!requested[category]) return;
      rotations[category].forEach(function (id) {
        var facts = RECIPE_FACTS[id], recipe = builderById[id];
        if (!facts || !recipe || recipe.supplierSku !== facts.supplierSku || recipe.category !== facts.category || facts.claimState !== 'exact-current' || facts.transitionWatch || !Number.isSafeInteger(facts.servingsPerTin) || facts.servingsPerTin <= 0 || (diet === 'vegetarian' && !facts.vegetarian)) errors.push('A recipe specification could not be verified.');
      });
    });
    if (errors.length) return invalid(['A recipe specification could not be verified. Please reload the page.']);

    var quantities = {};
    var categoryCases = { breakfast: 0, main: 0, pudding: 0 };
    function addCase(category) {
      var rotation = rotations[category];
      var id = rotation[categoryCases[category] % rotation.length];
      var next = (quantities[id] || 0) + 1;
      if (next > catalogueData.maximumCasesPerRecipe) return false;
      quantities[id] = next;
      categoryCases[category] += 1;
      supplied[category] += RECIPE_FACTS[id].servingsPerTin * catalogueData.tinsPerCase;
      return true;
    }
    // Fixed prefixes make every recipe quantity monotonic as the household or
    // duration grows. No previous recipe is exchanged to inflate a duration.
    for (var categoryIndex = 0; categoryIndex < CATEGORY_KEYS.length; categoryIndex += 1) {
      var category = CATEGORY_KEYS[categoryIndex];
      while (supplied[category] < requested[category]) {
        if (!addCase(category)) return invalid('This plan is larger than the recipe calculator supports. Please request a quote.');
      }
    }
    var casesBeforeMinimum = CATEGORY_KEYS.reduce(function (total, key) { return total + categoryCases[key]; }, 0);
    // Each requested category already has complete cases covering its demand.
    // Do not inflate a smaller plan merely to reach the free-delivery threshold.
    var build = catalogue.calculateBuild(quantities);
    if (!build || !build.valid || build.items.some(function (item) { return item.specConfirmationRequired; })) return invalid('This selection needs a recipe check before it can be recommended.');
    var extra = {};
    var categoryCoverageDays = {};
    CATEGORY_KEYS.forEach(function (key) {
      extra[key] = supplied[key] - requested[key];
      categoryCoverageDays[key] = pattern[key] ? Math.floor(supplied[key] / (people * pattern[key])) : null;
    });
    var coverageDays = Math.min.apply(Math, CATEGORY_KEYS.filter(function (key) { return requested[key] > 0; }).map(function (key) { return categoryCoverageDays[key]; }));
    var selection = build.items.map(function (item) {
      return {
        id: item.recipeId, recipeId: item.recipeId, name: item.name, category: item.category,
        quantity: item.quantity, tins: item.quantity * catalogueData.tinsPerCase,
        servings: item.quantity * catalogueData.tinsPerCase * RECIPE_FACTS[item.recipeId].servingsPerTin,
        servingsPerTin: RECIPE_FACTS[item.recipeId].servingsPerTin,
        supplierSku: item.supplierSku, specConfirmationRequired: item.specConfirmationRequired
      };
    });
    return {
      valid: true, errors: [], version: '1.9.11', people: people, months: months, days: planner.days,
      pattern: input.pattern === 'main' ? 'm' : input.pattern, patternId: patternId, diet: diet,
      selection: selection, quantities: quantities,
      requestedServings: requested, suppliedServings: supplied, extraServings: extra,
      breakfastServings: supplied.breakfast, mainServings: supplied.main, puddingServings: supplied.pudding,
      categoryCoverageDays: categoryCoverageDays, coverageDays: coverageDays, actualDays: coverageDays,
      cases: build.caseCount, tins: build.tinCount, categoryCases: categoryCases,
      minimumOrderUpsize: build.caseCount > casesBeforeMinimum,
      minimumOrderExtraCases: build.caseCount - casesBeforeMinimum,
      subtotalPence: build.subtotalPence, savingPence: build.savingPence, pricePence: build.pricePence,
      discountBasisPoints: build.discountBasisPoints, journey: build.journey,
      delivery: reserveApi.deliveryForSelection(build),
      build: build, planner: planner,
      planToken: reserveApi.encodePlannerState(planner), selectionToken: reserveApi.encodeSelection(build),
      availabilityStatus: 'unconfirmed', portionBasis: 'supplier-declared recipe servings',
      completeNutrition: false, wholeCases: true
    };
  }

  function customise(catalogueData, input, quantities) {
    var core = defaultReserveApi(), original = recommendWithApi(core, catalogueData, input);
    if (!original.valid) return original;
    var catalogue = core.createCatalogue(catalogueData), build = catalogue.calculateBuild(quantities);
    if (!build.valid || build.items.some(function(item) { var f=RECIPE_FACTS[item.recipeId]; return !f || (input.diet === 'vegetarian' && !f.vegetarian); })) return invalid('That customised selection could not be restored.');
    var supplied = { breakfast:0, main:0, pudding:0 }, cases = { breakfast:0, main:0, pudding:0 };
    var selection = build.items.map(function(item) {
      var facts=RECIPE_FACTS[item.recipeId], category=item.category==='dessert'?'pudding':item.category, servings=item.quantity*6*facts.servingsPerTin;
      supplied[category]+=servings; cases[category]+=item.quantity;
      return Object.assign({},item,{id:item.recipeId,tins:item.quantity*6,servings:servings,servingsPerTin:facts.servingsPerTin});
    });
    var pattern=core.plannerPatterns[original.patternId],coverage={},extra={};
    CATEGORY_KEYS.forEach(function(key){coverage[key]=pattern[key]?Math.floor(supplied[key]/(original.people*pattern[key])):null;extra[key]=supplied[key]-original.requestedServings[key];});
    var days=Math.min.apply(Math,CATEGORY_KEYS.filter(function(k){return original.requestedServings[k]>0;}).map(function(k){return coverage[k];}));
    return Object.assign({},original,{customised:true,build:build,selection:selection,quantities:Object.assign({},quantities),suppliedServings:supplied,breakfastServings:supplied.breakfast,mainServings:supplied.main,puddingServings:supplied.pudding,extraServings:extra,categoryCases:cases,categoryCoverageDays:coverage,coverageDays:days,actualDays:days,cases:build.caseCount,tins:build.tinCount,pricePence:build.pricePence,subtotalPence:build.subtotalPence,journey:build.journey,delivery:core.deliveryForSelection(build),selectionToken:core.encodeSelection(build)});
  }

  var api = Object.freeze({
    version: '1.9.32',
    customise: customise,
    recommend: function (catalogueData, input) { return recommendWithApi(defaultReserveApi(), catalogueData, input); },
    createEngine: function (reserveApi) { return Object.freeze({ recommend: function (catalogueData, input) { return recommendWithApi(reserveApi, catalogueData, input); } }); },
    recipeFacts: RECIPE_FACTS,
    rotations: ROTATIONS
  });
  if (typeof window !== 'undefined') window.PrepareHQShoppingEngine = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
}());
